import { render, staticRenderFns } from "./safety-stocks-info-modal.vue?vue&type=template&id=0ee4ce8b&scoped=true&"
import script from "./safety-stocks-info-modal.vue?vue&type=script&lang=js&"
export * from "./safety-stocks-info-modal.vue?vue&type=script&lang=js&"
import style0 from "./safety-stocks-info-modal.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./safety-stocks-info-modal.vue?vue&type=style&index=1&id=0ee4ce8b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee4ce8b",
  null
  
)

export default component.exports